import { compose, get, flatMap, map, uniq } from 'lodash/fp';

export const getRateIdsFromServicePricing = compose(
    uniq,
    map(get('rateId')),
    flatMap('ratePrices'),
    flatMap('rateGroupPricing'),
    flatMap('occupancyPricing'),
    get('offer')
);
